export default __webpack_public_path__ + "static/media/sc3.8d9ce380.png";